/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography2 } from '@coursera/cds-core';

import { CREDIT_CARD_SAFETY_LINK } from 'bundles/account-settings/constants/SettingsConstants';

import _t from 'i18n!nls/account-settings';

const styles = {
  notice: css`
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-50);
    align-items: baseline;
  `,
};

const CdsCreditCardSafetyNotice = () => (
  <div css={styles.notice}>
    <Typography2 variant="bodySecondary" component="span" color="supportText">
      {_t('Your payment information is stored securely.')}
    </Typography2>
    <Link
      href={CREDIT_CARD_SAFETY_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label={_t('Learn more about saving payment information')}
      typographyVariant="bodySecondary"
    >
      {_t('Learn more')}.
    </Link>
  </div>
);

export default CdsCreditCardSafetyNotice;
